import React from 'react'
import { View } from 'react-native'

import type { FooterProps } from '@ui-kit/components/BottomSheet/types'

const Footer = (props: FooterProps) => (
  // TODO we need to update approach for using z-index
  // Ticket: https://hellogetsafe.atlassian.net/browse/BX-802
  <View className="absolute bottom-0 left-0 right-0 z-[9999] flex h-[80px] flex-col justify-center bg-ui-light px-6 pb-5 pt-6">
    <View className="w-full">{props.footer}</View>
  </View>
)

export default Footer
